import React, { FunctionComponent, RefObject, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { getQuestionBlockData } from '../SurveyBuilder/utils';
import RegularButton from '../../../../components/RegularButton';
import Icon from '../../../../components/Icon';
import styles from './styles.module.scss';
import DraggableQuestionTable from '../DraggableQuestionTable';
import SoftSkillsTable from '../SoftSkillsTable';
import QuestionsPage from '../QuestionsPage';
import SoftSkillsPage from '../SoftSkillsPage';
import ModalWindow from '../../../../components/ModalWindow';
import { QuestionSection } from '../../../../common/enums/QuestionSection';

interface IProps {
  containerRef: RefObject<HTMLElement>;
  type: QuestionSection;
}

const QuestionTab: FunctionComponent<IProps> = ({ type, containerRef }) => {
  const { title, tip, description } = getQuestionBlockData(type);
  const [isQuestionBankShown, setIsQuestionBankShown] = useState(false);

  const onCloseModal = () => setIsQuestionBankShown(false);

  const getQuestionPage = () => {
    switch (type) {
      case QuestionSection.Questions:
        return <QuestionsPage onClose={onCloseModal} />;
      case QuestionSection.SoftSkills:
        return <SoftSkillsPage onClose={onCloseModal} />;
      default:
        return null;
    }
  };

  return (
    <>
      <ModalWindow
        isShown={isQuestionBankShown}
        onHide={onCloseModal}
        contentClassName={`${styles.questionBankModal} modal-wrapper`}
      >
        {getQuestionPage()}
      </ModalWindow>
      <div className={`${styles.header} d-flex align-items-center`}>
        <div className="d-flex flex-column">
          <span className="t-18 avenir-font mb-1">
            <FormattedMessage {...title} />
          </span>
          <span className={`t-14 ${styles.headerDesc}`}>
            <FormattedMessage {...description} />
          </span>
          {tip && (
            <div className={styles.tip}>
              <Icon icon="info" />
              <span><FormattedMessage {...tip} /></span>
            </div>
          )}
        </div>
        <div className={styles.questionBankBttn}>
          <RegularButton
            textIntlId="surveyBuilder.bank"
            defaultMessage="Question bank"
            icon={<Icon icon="plus" />}
            variant="secondary"
            onClick={() => setIsQuestionBankShown(true)}
          />
        </div>
      </div>
      {type === QuestionSection.SoftSkills
        ? <SoftSkillsTable openQuestionBank={() => setIsQuestionBankShown(true)} />
        : (
          <DraggableQuestionTable
            containerRef={containerRef}
            openQuestionBank={() => setIsQuestionBankShown(true)}
          />
        )}
    </>
  );
};

export default QuestionTab;
